// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealtimeModeEnum } from './RealtimeModeEnum';
import {
    RealtimeModeEnumFromJSON,
    RealtimeModeEnumFromJSONTyped,
    RealtimeModeEnumToJSON,
    RealtimeModeEnumToJSONTyped,
} from './RealtimeModeEnum';
import type { TransportModeEnum } from './TransportModeEnum';
import {
    TransportModeEnumFromJSON,
    TransportModeEnumFromJSONTyped,
    TransportModeEnumToJSON,
    TransportModeEnumToJSONTyped,
} from './TransportModeEnum';
import type { PTViaReference } from './PTViaReference';
import {
    PTViaReferenceFromJSON,
    PTViaReferenceFromJSONTyped,
    PTViaReferenceToJSON,
    PTViaReferenceToJSONTyped,
} from './PTViaReference';
import type { DatedVehicleJourneyReference } from './DatedVehicleJourneyReference';
import {
    DatedVehicleJourneyReferenceFromJSON,
    DatedVehicleJourneyReferenceFromJSONTyped,
    DatedVehicleJourneyReferenceToJSON,
    DatedVehicleJourneyReferenceToJSONTyped,
} from './DatedVehicleJourneyReference';
import type { ScheduledStopPointReference } from './ScheduledStopPointReference';
import {
    ScheduledStopPointReferenceFromJSON,
    ScheduledStopPointReferenceFromJSONTyped,
    ScheduledStopPointReferenceToJSON,
    ScheduledStopPointReferenceToJSONTyped,
} from './ScheduledStopPointReference';

/**
 * Request parameters (POST body).
 * @export
 * @interface TripsByLegRequestBody
 */
export interface TripsByLegRequestBody {
    /**
     * 
     * @type {DatedVehicleJourneyReference}
     * @memberof TripsByLegRequestBody
     */
    ptRideLegReference: DatedVehicleJourneyReference;
    /**
     * Final destination **`StopPlace`** of the planned Trip, relates to current position in `ptRideLegReference`. See [**PlaceReference**](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/JSON-Objects.md#placereference)
     * @type {string}
     * @memberof TripsByLegRequestBody
     */
    destination: string;
    /**
     * Current date of passenger on `ptRideLegReference` related to `time`, defaults to TODAY.
     * @type {Date}
     * @memberof TripsByLegRequestBody
     */
    date?: Date;
    /**
     * Current (local) time of passenger on `ptRideLegReference` related to `date`, defaults to NOW.
     * @type {string}
     * @memberof TripsByLegRequestBody
     */
    time?: string;
    /**
     * 
     * @type {ScheduledStopPointReference}
     * @memberof TripsByLegRequestBody
     */
    transferStopPoint?: ScheduledStopPointReference;
    /**
     * Relates to `transferStopPoint::dateTime`. Distinguishes between arrival or departure dateTime at `transferStopPoint`.
     * @type {boolean}
     * @memberof TripsByLegRequestBody
     */
    transferStopPointAtArrival?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TripsByLegRequestBody
     */
    operators?: Array<string>;
    /**
     * Max. number of Vehicle changes. The parameter is relevant between origin and destination or between origin and ptVias[0] if any among all `PTRideLeg's`.
     * @type {number}
     * @memberof TripsByLegRequestBody
     */
    maxTransfers?: number;
    /**
     * 
     * @type {Array<PTViaReference>}
     * @memberof TripsByLegRequestBody
     */
    vias?: Array<PTViaReference>;
    /**
     * 
     * @type {RealtimeModeEnum}
     * @memberof TripsByLegRequestBody
     */
    realtimeMode?: RealtimeModeEnum;
    /**
     * Maximum number of results to be returned, related to parameter `duration` and may reduce or expand `limit` settings.
     * @type {number}
     * @memberof TripsByLegRequestBody
     */
    limit?: number;
    /**
     * Duration of interval in minutes. Choose wisely, in most cases next 120min are sufficient!<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {number}
     * @memberof TripsByLegRequestBody
     */
    duration?: number;
    /**
     * 
     * @type {Set<TransportModeEnum>}
     * @memberof TripsByLegRequestBody
     */
    includeTransportModes?: Set<TransportModeEnum>;
    /**
     * 
     * @type {Array<DatedVehicleJourneyReference>}
     * @memberof TripsByLegRequestBody
     */
    excludeDatedVehicleJourneys?: Array<DatedVehicleJourneyReference>;
}



/**
 * Check if a given object implements the TripsByLegRequestBody interface.
 */
export function instanceOfTripsByLegRequestBody(value: object): value is TripsByLegRequestBody {
    if (!('ptRideLegReference' in value) || value['ptRideLegReference'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    return true;
}

export function TripsByLegRequestBodyFromJSON(json: any): TripsByLegRequestBody {
    return TripsByLegRequestBodyFromJSONTyped(json, false);
}

export function TripsByLegRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsByLegRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'ptRideLegReference': DatedVehicleJourneyReferenceFromJSON(json['ptRideLegReference']),
        'destination': json['destination'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'time': json['time'] == null ? undefined : json['time'],
        'transferStopPoint': json['transferStopPoint'] == null ? undefined : ScheduledStopPointReferenceFromJSON(json['transferStopPoint']),
        'transferStopPointAtArrival': json['transferStopPointAtArrival'] == null ? undefined : json['transferStopPointAtArrival'],
        'operators': json['operators'] == null ? undefined : json['operators'],
        'maxTransfers': json['maxTransfers'] == null ? undefined : json['maxTransfers'],
        'vias': json['vias'] == null ? undefined : ((json['vias'] as Array<any>).map(PTViaReferenceFromJSON)),
        'realtimeMode': json['realtimeMode'] == null ? undefined : RealtimeModeEnumFromJSON(json['realtimeMode']),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'includeTransportModes': json['includeTransportModes'] == null ? undefined : (new Set((json['includeTransportModes'] as Array<any>).map(TransportModeEnumFromJSON))),
        'excludeDatedVehicleJourneys': json['excludeDatedVehicleJourneys'] == null ? undefined : ((json['excludeDatedVehicleJourneys'] as Array<any>).map(DatedVehicleJourneyReferenceFromJSON)),
    };
}

  export function TripsByLegRequestBodyToJSON(json: any): TripsByLegRequestBody {
      return TripsByLegRequestBodyToJSONTyped(json, false);
  }

  export function TripsByLegRequestBodyToJSONTyped(value?: TripsByLegRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ptRideLegReference': DatedVehicleJourneyReferenceToJSON(value['ptRideLegReference']),
        'destination': value['destination'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'time': value['time'],
        'transferStopPoint': ScheduledStopPointReferenceToJSON(value['transferStopPoint']),
        'transferStopPointAtArrival': value['transferStopPointAtArrival'],
        'operators': value['operators'],
        'maxTransfers': value['maxTransfers'],
        'vias': value['vias'] == null ? undefined : ((value['vias'] as Array<any>).map(PTViaReferenceToJSON)),
        'realtimeMode': RealtimeModeEnumToJSON(value['realtimeMode']),
        'limit': value['limit'],
        'duration': value['duration'],
        'includeTransportModes': value['includeTransportModes'] == null ? undefined : (Array.from(value['includeTransportModes'] as Set<any>).map(TransportModeEnumToJSON)),
        'excludeDatedVehicleJourneys': value['excludeDatedVehicleJourneys'] == null ? undefined : ((value['excludeDatedVehicleJourneys'] as Array<any>).map(DatedVehicleJourneyReferenceToJSON)),
    };
}

